import { Tab as MuiTab, Tabs as MuiTabs } from '@mui/material'
import { includes } from 'lodash'
import { generatePath, Navigate, useNavigate, useParams } from 'react-router-dom'

import Paper from 'components/Paper'
import { ROUTES } from 'routes'
import { SectionTab, SectionTabsProps, SectionTabsUrlParams } from './types'

export const SectionTabs = <T extends string>({
  path,
  sections,
}: SectionTabsProps<T>): JSX.Element => {
  const navigate = useNavigate()
  const { id, section: urlSection, tab: urlTab, workspaceId } = useParams<SectionTabsUrlParams<T>>()

  if (
    !urlSection ||
    !includes(
      sections.map((t: SectionTab<T>): T => t.element),
      urlSection,
    )
  ) {
    return <Navigate to={ROUTES.BASE.NOT_FOUND} />
  }

  const handleTabClick = (section: SectionTab<T>): void => {
    navigate(
      generatePath(path, {
        id,
        section: section.element,
        tab: urlTab,
        workspaceId,
      }),
    )
  }

  return (
    <Paper
      spacing='m'
      sx={{
        p: 3,
      }}
    >
      <MuiTabs
        orientation='vertical'
        sx={{
          '.MuiTabs-flexContainerVertical': {
            alignItems: 'flex-start',
          },
          '.MuiTabs-indicator': {
            display: 'none',
          },
        }}
        value={urlSection}
      >
        {sections.map((section: SectionTab<T>): JSX.Element => {
          const { disabled, element, label } = section

          return (
            <MuiTab
              data-cy={element}
              disabled={disabled}
              key={element}
              label={label}
              onClick={(): void => handleTabClick(section)}
              value={element}
            />
          )
        })}
      </MuiTabs>
    </Paper>
  )
}
